import { render } from "./taxonlist.vue?vue&type=template&id=1bd3eaf2&scoped=true"
import script from "./taxonlist.vue?vue&type=script&lang=js"
export * from "./taxonlist.vue?vue&type=script&lang=js"

import "./taxonlist.vue?vue&type=style&index=0&id=1bd3eaf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd3eaf2"]])

export default __exports__